import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>Sorry,This page is not found</h1>
            <h3>ERROR 404</h3>
        </div>
    );
};

export default NotFound;